import {
  GreenMagnifyingGlassIllustration,
  NoResultIllustration,
} from '@carboncopyco/illustrations';
import { TextBase, TextButton } from '@carboncopyco/ui';
import type React from 'react';
interface NoResultModalSectionProps {
  children?: React.ReactNode;
  noSearchResult?: boolean;
}

interface NoResultViewItems {
  headerImage: React.ReactNode;
  mainText: string;
}

type NoResultViewType = 'noSearchResult' | 'error';
export const NoResultModalSection = ({
  children,
  noSearchResult,
}: NoResultModalSectionProps) => {
  const noResultView: Record<NoResultViewType, NoResultViewItems> = {
    noSearchResult: {
      headerImage: <GreenMagnifyingGlassIllustration />,
      mainText: 'Nothing matches your current search',
    },
    error: {
      headerImage: <NoResultIllustration />,
      mainText:
        "It appears that we couldn't find any matches for your request.\n" +
        '       You can try generating the prompt again with different phrasing\n' +
        '       to see if that helps.',
    },
  };
  const item = noResultView[noSearchResult ? 'noSearchResult' : 'error'];
  return (
    <div className="h-full pb-5 flex flex-col justify-center items-center gap-4 whitespace-pre-line text-center">
      <>
        {item.headerImage}
        <TextButton
          label="Oops..."
          color="text-ds-natural-600"
        />
        <TextBase
          label={item.mainText}
          color="text-ds-natural-600"
        />
      </>
      {children}
    </div>
  );
};
